module.exports = __webpack_public_path__ + "static/img/02imgSchool.3ef0598b.png";